import { StaticImage } from "gatsby-plugin-image";
import * as React from "react";

export default function Example() {
  return (
    <>
      <div className="relative pt-6 pb-8 bg-qe-light-blue">
        <nav
          className="relative max-w-7xl mx-auto flex items-center justify-between px-4 sm:px-6"
          aria-label="Global"
        >
          <div className="flex items-center flex-1">
            <div className="flex items-center justify-between w-full md:w-auto">
              <a href="/recherche">
                <span className="sr-only">Qualifelec</span>
                <StaticImage
                  src="../../images/logo.png"
                  alt="Logo Qualifelec"
                  placeholder="none"
                  width={100}
                  height={129}
                />
              </a>
            </div>
          </div>
        </nav>
      </div>
    </>
  );
}
